import { Message } from '@arco-design/web-react';
import { matchRoutes, RequestConfig } from 'umi';

import {
  API_ERROR_MESSAGE,
  ErrorReason,
  TOKEN_VALID_REASON,
} from './apis/error';
import { APP_VERSION } from './constants';
import './globals.css';
import { gotoFortress, initFortress, loginFortress } from './utils/fortress';
import { getToken, removeToken, setToken } from './utils/storage';

Message.config({
  maxCount: 2,
});

if (APP_VERSION) {
  console.log(`[ModelFlow Frontend Logger] VERSION: ${APP_VERSION}`);
}

interface APIError {
  code: number;
  message: string;
  metadata: Record<string, any>;
  reason: string;
}

// 是否已经检验过
let loggingIn = false;
initFortress({
  appId: process.env.CIAM_APPID ?? '',
  redirect: {
    origin: process.env.CIAM_ORIGIN ?? '',
    pathname: `/zh-CN/passport/signin`,
  },
  verify: {
    url: '/api/v1/auth/login-by-cticket',
    debounce: 500,
    beforeFn() {
      removeToken();
    },
    afterFn: (v: { token: string }) => {
      setToken(v.token);

      const url = new URL(window.location.href);
      url.searchParams.delete('cTicket');
      window.location.href = url.href;
    },
    catchFn(error: APIError) {
      if (error.code === 401) {
        gotoFortress();

        return;
      }
    },
  },
});

export const request: RequestConfig = {
  baseURL: '/api/v1',
  requestInterceptors: [
    (url: string, options: any) => {
      options.headers['Authorization'] = `Bearer ${getToken()}`;

      return {
        url,
        options,
      };
    },
  ],
  errorConfig: {
    // 错误接收及处理
    errorHandler(error: any, opts: any) {
      if (opts?.skipErrorHandler) throw error;

      const data = error.response.data;

      if (TOKEN_VALID_REASON.includes(data.reason)) {
        removeToken();
        if (!loggingIn) {
          loginFortress();
          loggingIn = true;
        }

        return;
      }

      const errorMessage =
        API_ERROR_MESSAGE[data.reason as ErrorReason] ||
        error.response.data.message;

      if (errorMessage) {
        Message.error(errorMessage);
      }
    },
  },
};

export function onRouteChange({
  clientRoutes,
  location,
}: {
  clientRoutes: any[];
  location: Location;
}) {
  const route = matchRoutes(clientRoutes, location.pathname)?.pop()?.route;

  if (route) {
    document.title =
      (route as { title: string }).title || 'ModelFlow - 模型转换工具';
  }
}
